import { BrowserRouter, Navigate, Route, Routes } from "react-router";
import Layout from "./Layout";
import Home from "./components/Home";
import Users from "./components/Users";
import Versions from "./components/Versions";
import Worlds from "./components/Worlds";

const Routing: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="/worlds" element={<Worlds />} />
          <Route path="/versions" element={<Versions />} />
          <Route path="/users" element={<Users />} />
        </Route>
        <Route
          path="/login-redirect"
          element={<Navigate to="/worlds" replace />}
        />
      </Routes>
    </BrowserRouter>
  );
};

export default Routing;
